<template>
  <div class="upload-container" @mouseover="hover = true" @mouseleave="hover = false">
    <vue-base64-file-upload v-if="isLogo && !isBackground"
      accept="image/png,image/gif,image/jpeg"
      input-class="input-custom"
      image-class="img-fluid"
      placeholder=""
      :class="[ hover ? 'logo-uploader-hover' : '' , upload ? 'file-uploaded' : '', 'logo-uploader']"
      :max-size="customImageMaxSize"
      @size-exceeded="onSizeExceeded"
      @file="onFile"
      @load="onLoadLogo"
    />
    <vue-base64-file-upload v-else-if="isBackground && !isLogo"
      accept="image/png,image/gif,image/jpeg"
      input-class="input-custom"
      image-class="img-fluid"
      placeholder=""
      :class="[ hover ? 'background-uploader-hover' : '' , upload ? 'file-uploaded' : '', 'background-uploader']"
      :max-size="customImageMaxSize"
      @size-exceeded="onSizeExceeded"
      @file="onFile"
      @load="onLoadBackground"
    />
    <div v-else>Component is incorrectly registered.</div>
  </div>
</template>

<script>
  import VueBase64FileUpload from 'vue-base64-file-upload';

  export default {
    data() {
      return {
        hover: false,
        upload: false
      };
    },
    components: {
      VueBase64FileUpload,
    },
    props: {
      isLogo: {
        default: false,
        type: Boolean,
      },
      isBackground: {
        default: false,
        type: Boolean,
      },
      customImageMaxSize: {
        type: Number,
        default: 2
      },
      jsonCode: Object
    },
    methods: {
      removeFile() {
        const button = this.$el.querySelector('.reset-component')
        this.displayImage(false)
        this.resetLoadState()
        this.hideWrapper(false)
        button.remove()
      },
      displayImage(bool) {
        const img = this.$el.querySelector('.img-fluid')
        if (bool) {
          img.style.display = 'inherit'
        }
        else {
          img.style.display = 'none'
          img.src = ''
        }
      },
      resetLoadState() {
        if (this.loadLogo) {
          this.jsonCode.CompanyLogoEncodedPNGString = ''
          this.loadLogo = false
        }
        else if (this.loadBackground) {
          this.jsonCode.BackgroundPictureEncodedPNGString = ''
          this.loadBackground = false
        }
        this.hover = false
        this.upload = false
      },
      cloneTextInput() {
        const wrapper = this.$el.querySelector('.vue-base64-file-upload-wrapper')
        const textInput = this.$el.querySelector('input[type=text]')
        const clone = textInput.cloneNode(true)
        wrapper.appendChild(clone)
        this.hideWrapper(true)
        textInput.remove()
      },
      addButton() {
        const VueBase64FileUpload = this.$el.querySelector('.vue-base64-file-upload'); 
        const button = document.createElement('div')
        button.classList.add('reset-component')
        button.addEventListener('click', () => {
          this.removeFile()
        })
        VueBase64FileUpload.appendChild(button);
      },
      hideWrapper(bool) {
        const wrapper = this.$el.querySelector('.vue-base64-file-upload-wrapper')
        if (bool) {
          wrapper.style.display = 'none'
        }
        else {
          wrapper.style.display = 'inherit'
        }
      },
      onFile() {
        this.cloneTextInput()
        this.displayImage(true)
      },
      onLoadLogo(dataUri) {
        this.hideWrapper(true)
        this.addButton()

        this.jsonCode.CompanyLogoEncodedPNGString = dataUri
        this.upload = true
        this.loadLogo = true
      },
      onLoadBackground(dataUri) {
        this.hideWrapper(true)
        this.addButton()

        this.jsonCode.BackgroundPictureEncodedPNGString = dataUri
        this.upload = true
        this.loadBackground = true
      },
      onSizeExceeded(size) {
          alert(`Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`);
      },
      displayHex(string) {
        return string.slice(1).toUpperCase()
      },
      setAspectRatio(ratio) {
        const htmlel = this.$el.querySelector('.input-custom')
        htmlel.style.aspectRatio = ratio
      }
    },
    created() {
      let component = this

      let svg = new Image()
      svg.src = 'src/assets/upload-image.svg'
      svg.onload = function() {
        component.setAspectRatio(svg.width/svg.height)
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/Parameters/ParameterUpload.vue